import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '../_shared/shared.service';
import { HotelListing } from './hotel-listing';

/**
 * Hotel Room V2 — REST client for the str_hotel_listing table.
 * Sibling of CompositeListingService; targets /api/2.6/hotel-listings.
 */
@Injectable({ providedIn: 'root' })
export class HotelListingService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];

	sitePriorities = [
		{ name: 'Priority 1', value: 1 },
		{ name: 'Priority 2', value: 2 },
		{ name: 'Priority 3', value: 3 },
		{ name: 'Priority 4', value: 4 },
		{ name: 'Priority 5', value: 5 },
		{ name: 'Priority 6', value: 6 },
		{ name: 'Priority 7', value: 7 },
		{ name: 'Priority 8', value: 8 },
		{ name: 'Priority 9', value: 9 },
		{ name: 'Priority 10', value: 10 },
	];

	constructor(
		private http: HttpClient,
		private alertService: AlertService,
		private sharedService: SharedService
	) { }

	urlEndpoint = 'hotel-listings';

	add(hotelListing: HotelListing): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(hotelListing));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, hotelListing);
	}

	update(hotelListing: HotelListing): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, hotelListing);
	}

	delete(hotelListingId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${hotelListingId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	/**
	 * Hotel Room V2 (Phase 2) — admin trigger for re-binding RU sub-unit IDs (UnitId / ResApaID)
	 * to the hotel-room's children. POST /api/2.6/hotel-listings/{strId}/rebind-ru-sub-units.
	 */
	rebindRuSubUnits(shortTermRentalId: number): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${shortTermRentalId}/rebind-ru-sub-units`, {});
	}
}
